import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const AddCandidateToCampainWrapper = styled.div`
  .selected-offer {
    margin: 20px auto;
  }
`
